/* eslint-disable */ 
import React from 'react'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'

const RadioButtonInput = field => (
  <label
    htmlFor={field.value}
    style={{ display: 'flex', alignItems: 'center' }}
  >
    <input
      {...field.input}
      id={field.value}
      type={field.type}
      disabled={field.disabled}
      className="form-check-input"
      checked={field.selected}
    />
    {/* {field.meta.touched &&
      field.meta.error &&
      <span className={classes.error}>{field.meta.error}</span>} */}
    <Box marginLeft="1rem" lineHeight="1">
      <Typography
        variant="body1"
        style={field.labelSpanStyle}
        className={field.lbelLengthStyel}
      >
        {field.label}
      </Typography>
      {field.description && <Typography variant="body2">{field.description}</Typography>}
    </Box>
  </label>
)

export default RadioButtonInput



// WEBPACK FOOTER //
// ./src/legacy/containers/Forms/components/RadioButtonInput/RadioButtonInput.jsx